import {
  SearchContext,
  ISearchContext,
} from '@components/site/providers/SearchProvider'
import { useContext } from 'react'

export default function useSearchState(): ISearchContext {
  return useContext(SearchContext)
}
